// extracted by mini-css-extract-plugin
export default {"item":"CategoryList_item__rNuq0","add":"CategoryList_add__jzhMv","icon":"CategoryList_icon__K1v89","wrapper":"CategoryList_wrapper__DDmYa","round":"CategoryList_round__CELm4"};